import { render, staticRenderFns } from "./SubjectChip.vue?vue&type=template&id=5d2a4fba&scoped=true&"
import script from "./SubjectChip.vue?vue&type=script&lang=js&"
export * from "./SubjectChip.vue?vue&type=script&lang=js&"
import style0 from "./SubjectChip.vue?vue&type=style&index=0&id=5d2a4fba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a4fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
